import { withHandlers, compose } from 'recompose'
import { connect } from 'react-redux'
import { createSavedLocationSearchForm } from 'components/common/SavedLocationSearchForm'
import { activateGoogleOptimize } from 'actions/thirdParty'
import { getSearchByAddressParams } from 'helpers/storeLocator'
import { activateMarchexScript } from 'helpers/custom-events'
import { SEARCH_BY_LOCATION, LOCATION_FINDER_INPUT } from 'constant'

const withSubmit = withHandlers({
  onSubmit: ({
    fetchLocationsByAddrWithDefaultDistance,
    setInitialSearchMethodAction,
    coords,
    activateGoogleOptimize,
    useMyLocationClicked,
    setUseMyLocationClicked
  } = {}) =>
    ({ [LOCATION_FINDER_INPUT]: searchMask } = {}, fn, { form }) => {
      activateMarchexScript()
      activateGoogleOptimize()
      useMyLocationClicked && setUseMyLocationClicked(false)
      const searchByAddressParams = getSearchByAddressParams(coords)

      setInitialSearchMethodAction(SEARCH_BY_LOCATION)
      fetchLocationsByAddrWithDefaultDistance(searchMask, searchByAddressParams, form)
    }
})

const withSubmitHOCs = compose(
  connect(null, { activateGoogleOptimize }),
  withSubmit
)

export const AvailableResultsForm = withSubmitHOCs(createSavedLocationSearchForm({ name: 'searchWhenResultsAreAvailable' }))

export const SearchFromHeader = withSubmitHOCs(createSavedLocationSearchForm({ name: 'searchFromHeader' }))

export const SavedLocationSearchForm = withSubmitHOCs(createSavedLocationSearchForm())
